import React from 'react';
import { Link } from 'react-router-dom';
import { GlassPage } from '../components/chrome';

const Unsubscribe = () => (
  <GlassPage>
    <div className="max-w-lg mx-auto px-4 md:px-6 pt-28 md:pt-36">
      <section className="glass px-8 md:px-12 py-12 md:py-16 text-center">
        <div className="mx-auto w-16 h-16 rounded-full border border-green-500/30 bg-green-500/10 flex items-center justify-center text-green-600 mb-8">
          <svg width={28} height={28} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" xmlns="http://www.w3.org/2000/svg">
            <polyline points="20 6 9 17 4 12" />
          </svg>
        </div>
        <h1 className="text-3xl md:text-4xl font-bold tracking-tighter uppercase text-zinc-900 mb-4">Unsubscribed</h1>
        <p className="text-sm md:text-base text-zinc-600 leading-relaxed mb-10">
          You've been unsubscribed successfully. You won't receive any more emails from us.
        </p>
        <Link to="/" className="text-[10px] font-bold uppercase tracking-widest text-zinc-600 hover:text-zinc-900 transition-colors">
          Back to home →
        </Link>
      </section>
    </div>
  </GlassPage>
);

export default Unsubscribe;
